import { createApp } from 'vue'
import { getParam } from '~/js/helpers/url-helper'
import {
  ERROR_MESSAGE_UNEXPECTED,
  ERROR_MESSAGE_INVALID_TOKEN,
} from '~/js/constants/errorMessages'

import axios from 'axios'

const ID_PAGE_EMAIL_CHANGE_CONFIRM = 'js-page-email-change-confirm'

document.addEventListener('DOMContentLoaded', async () => {
  const elementPageEmailChangeConfirm = document.getElementById(
    ID_PAGE_EMAIL_CHANGE_CONFIRM
  )
  if (!elementPageEmailChangeConfirm) return

  const token = getParam('token')
  const { baseUrl } = elementPageEmailChangeConfirm.dataset

  let errorMessage = ''
  try {
    await axios.post(`${baseUrl}/customers/change_email/complete`, {
      token,
    })
  } catch (error) {
    const message = error.response.data.result

    switch (message) {
      case 'Invalid token':
        errorMessage = ERROR_MESSAGE_INVALID_TOKEN
        break
      default:
        errorMessage = ERROR_MESSAGE_UNEXPECTED
    }
    console.error(error)
  }

  createApp({
    name: 'PageEmailChangeConfirm',
    data() {
      return {
        isProcessing: false,
        errorMessage,
      }
    },
  }).mount(elementPageEmailChangeConfirm)
})
